const textSlideUp = () => {
  const $textSlideUp = $(".text-slide-up");
  $textSlideUp.each(function () {
    //thêm 1 phần tử 0 vào cuối để tạo hiệu ứng
    const $li = $(this).find("li");
    $(this).append($($li[0]).clone());

    const targets = $(this).find("li").toArray();
    let translateY = [];

    for (let i = 0; i < targets.length; i++) {

      translateY.push({
        value: `${-100 * i}%`,
        delay: i == 0 ? 0 : $(targets[i - 1]).data("delay") || 1000,
        duration: i == 0 ? 0 : $(targets[i]).data("speed") || 3000
      })
    }
    let animation = anime({
      targets: targets,
      translateY: translateY,
      easing: 'easeInOutQuint',
      loop: true
    });
    $textSlideUp.data("anime", animation)
  })
}

const animations = () => {
  textSlideUp();
}

module.exports = animations